(function initStickyNav() {
    const nav = document.querySelector('.sticky-nav');
    if (!nav) return;

    const defaultThreshold = parseInt(nav.dataset.threshold || '100', 10) || 100;
    const triggerSelector = nav.dataset.triggerSelector;
    const scroller = nav.querySelector('.sticky-nav__items');
    const items = Array.from(nav.querySelectorAll('.sticky-nav__item[data-target]'));
    const navContext = nav.dataset.context || 'product_detail';
    const manualVariantId = nav.dataset.manualVariantId;
    const variantIdSelector = nav.dataset.variantIdSelector;
    const quantitySelector = nav.dataset.quantitySelector;
    const moneyFormat =
      nav.dataset.moneyFormat ||
      (window.theme && window.theme.settings && window.theme.settings.money_with_currency_format);
    const showCompareAt = nav.dataset.showCompareAt === 'true';
    const rootUrl = (window.theme && window.theme.routes && window.theme.routes.root_url) || '/';
    const cartAddUrl = `${rootUrl.replace(/\/$/, '')}/cart/add.js`;
    const priceWrap = nav.querySelector('.sticky-nav__price');
    const priceEl = nav.querySelector('[data-sticky-nav-price]');
    const comparePriceEl = nav.querySelector('[data-sticky-nav-compare-price]');
    const actionButtons = Array.from(nav.querySelectorAll('[data-sticky-nav-action]'));
    const variantsJson = document.querySelector('[data-sticky-nav-variants]');
    let variants = variantsJson ? JSON.parse(variantsJson.textContent || '[]') : [];
    let activeItem = null;
    let currentVariant = null;

    const formatPrice = (price) => {
      if (typeof window.formatMoney === 'function') return window.formatMoney(price, moneyFormat);

      return (price / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
      });
    };

    const findVariantById = (variantId) => {
      if (!variantId) return null;
      return variants.find((variant) => String(variant.id) === String(variantId)) || null;
    };

    const getPageVariants = () => {
      const variantDataScripts = Array.from(
        document.querySelectorAll('variant-selects [type="application/json"], variant-radios [type="application/json"]')
      );

      return variantDataScripts.reduce((pageVariants, script) => {
        try {
          const parsedVariants = JSON.parse(script.textContent || '[]');
          if (Array.isArray(parsedVariants)) {
            pageVariants.push(...parsedVariants);
          }
        } catch (error) {
          // Ignore malformed variant JSON from unrelated widgets.
        }

        return pageVariants;
      }, []);
    };

    const refreshPageVariants = () => {
      if (navContext !== 'purchase_page') return;

      const pageVariants = getPageVariants();
      if (pageVariants.length) {
        variants = pageVariants;
      }
    };

    const getVariantFromPicker = () => {
      const pickers = Array.from(document.querySelectorAll('variant-selects, variant-radios'));
      const pickerWithVariant = pickers.find((picker) => picker.currentVariant && picker.currentVariant.id);

      return pickerWithVariant ? pickerWithVariant.currentVariant : null;
    };

    const getVariantIdFromSelector = () => {
      const selector = variantIdSelector || 'form[action*="/cart/add"] [name="id"]';
      const input = document.querySelector(selector);
      if (!input) return null;

      return input.value || input.getAttribute('value') || input.dataset.variantId || null;
    };

    const getQuantity = () => {
      const selector = quantitySelector || 'form[action*="/cart/add"] [name="quantity"]';
      const input = document.querySelector(selector);
      const quantity = input ? parseInt(input.value, 10) : 1;

      return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    };

    const setActionButtonsDisabled = (disabled) => {
      actionButtons.forEach((button) => {
        button.disabled = disabled;
        button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      });
    };

    const sectionsToRender = [
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer',
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count',
      },
    ];

    const getSectionInnerHTML = (html, selector) => {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    };

    const renderCartSections = (state) => {
      if (!state.sections) return;

      sectionsToRender.forEach((section) => {
        const container = document.getElementById(section.id);
        if (!container || !state.sections[section.section]) return;

        const elementToReplace = container.querySelector(section.selector) || container;
        elementToReplace.innerHTML = getSectionInnerHTML(state.sections[section.section], section.selector);
      });

      const cartDrawer = document.getElementById('Cart-Drawer');
      if (cartDrawer) {
        cartDrawer.removeProductEvent?.();
        cartDrawer.open?.();
      }
    };

    const showButtonSuccess = (button) => {
      if (!button || button.dataset.successTimer) return;

      const originalHtml = button.innerHTML;
      const originalWidth = button.getBoundingClientRect().width;
      button.style.width = `${originalWidth}px`;
      button.innerHTML =
        '<svg class="sticky-nav__btn-success-icon" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M13.5 4.5 6.8 11.2 2.5 6.9" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      const timer = window.setTimeout(() => {
        button.innerHTML = originalHtml;
        button.style.width = '';
        delete button.dataset.successTimer;
      }, 3000);

      button.dataset.successTimer = String(timer);
    };

    const updatePrice = (variant) => {
      if (!priceWrap || !priceEl) return;

      if (!variant || typeof variant.price !== 'number') {
        priceWrap.classList.add('hidden');
        setActionButtonsDisabled(!variant || !variant.id);
        return;
      }

      priceWrap.classList.remove('hidden');
      priceEl.textContent = formatPrice(variant.price);
      priceWrap.setAttribute('aria-label', formatPrice(variant.price));

      if (comparePriceEl) {
        const compareAtPrice = variant.compare_at_price || variant.compare_at_price_max || 0;
        if (showCompareAt && compareAtPrice > variant.price) {
          comparePriceEl.textContent = formatPrice(compareAtPrice);
          comparePriceEl.classList.remove('hidden');
        } else {
          comparePriceEl.textContent = '';
          comparePriceEl.classList.add('hidden');
        }
      }

      setActionButtonsDisabled(false);
    };

    const setCurrentVariant = (variant) => {
      currentVariant = variant || null;
      updatePrice(currentVariant);
    };

    const resolveCurrentVariant = () => {
      if (navContext === 'product_detail') return findVariantById(manualVariantId);

      const pickerVariant = getVariantFromPicker();
      if (pickerVariant && typeof pickerVariant.price === 'number') return pickerVariant;

      refreshPageVariants();
      const variantId = getVariantIdFromSelector();
      const matchedVariant = findVariantById(variantId);
      if (matchedVariant) return matchedVariant;

      return currentVariant || (variantId ? { id: variantId } : null);
    };

    const syncCurrentVariant = () => {
      setCurrentVariant(resolveCurrentVariant());
    };

    syncCurrentVariant();

    if (navContext === 'purchase_page') {
      if (document.readyState === 'loading') {
        window.addEventListener('DOMContentLoaded', syncCurrentVariant, { once: true });
      } else {
        syncCurrentVariant();
      }

      window.addEventListener('load', syncCurrentVariant, { once: true });
      window.setTimeout(syncCurrentVariant, 100);
      window.setTimeout(syncCurrentVariant, 500);

      if (window.customElements && typeof window.customElements.whenDefined === 'function') {
        window.customElements.whenDefined('variant-selects').then(() => {
          requestAnimationFrame(syncCurrentVariant);
        });
      }
    }

    document.addEventListener('product:variant-change', (event) => {
      if (navContext !== 'purchase_page') return;
      setCurrentVariant(event.detail && event.detail.variant ? event.detail.variant : resolveCurrentVariant());
    });

    document.addEventListener('change', (event) => {
      if (navContext !== 'purchase_page') return;
      const selector = variantIdSelector || 'form[action*="/cart/add"] [name="id"]';
      if (!event.target.matches(selector)) return;
      setCurrentVariant(resolveCurrentVariant());
    });

    actionButtons.forEach((button) => {
      button.addEventListener('click', async () => {
        const variant = resolveCurrentVariant();
        const variantId = variant && variant.id ? parseInt(variant.id, 10) : NaN;
        if (!Number.isFinite(variantId)) {
          setActionButtonsDisabled(true);
          return;
        }

        const quantity = getQuantity();
        const formData = {
          items: [{ id: variantId, quantity }],
          sections: sectionsToRender.map((section) => section.section),
          sections_url: window.location.pathname,
        };

        const response = await fetch(cartAddUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(formData),
        });

        if (!response.ok) {
          const errorText = await response.text();
          console.warn('Sticky nav cart add failed:', errorText);
          return;
        }
        const cartData = await response.json();
        renderCartSections(cartData);
        showButtonSuccess(button);

        document.dispatchEvent(
          new CustomEvent('cart:item-added', {
            detail: {
              product: cartData,
            },
          })
        );

      });
    });

    const getStickyThreshold = () => {
      if (!triggerSelector) return defaultThreshold;

      const trigger = document.querySelector(triggerSelector);
      if (!trigger) return defaultThreshold;

      return trigger.getBoundingClientRect().top + window.scrollY;
    };

    const updateSticky = () => {
      nav.classList.toggle('is-sticky', window.scrollY >= getStickyThreshold());
    };

    window.addEventListener('scroll', updateSticky, { passive: true });
    updateSticky();

    const getItemFromEvent = (event) => {
      const target =
        event.target && event.target.nodeType === Node.TEXT_NODE ? event.target.parentElement : event.target;

      return target && target.closest ? target.closest('.sticky-nav__item[data-target]') : null;
    };

    const scrollToItemTarget = (item) => {
      if (!item) return;

      const target = document.querySelector(item.dataset.target);
      if (!target) return;

      scrollActiveItemIntoView(item);
      const top = target.getBoundingClientRect().top + window.scrollY - nav.offsetHeight - 8;
      window.scrollTo({ top, behavior: 'smooth' });
    };

    items.forEach((item) => {
      item.addEventListener('click', () => {
        scrollToItemTarget(item);
      });
    });

    const updateScrollerState = () => {
      if (!scroller) return;
      scroller.classList.toggle('is-scrollable', scroller.scrollWidth > scroller.clientWidth + 1);
    };

    const initNativeDragScroll = () => {
      if (!scroller || scroller.dataset.dragScrollReady === 'true') return;
      scroller.dataset.dragScrollReady = 'true';

      let pointerId = null;
      let startX = 0;
      let startScrollLeft = 0;
      let hasMoved = false;
      let suppressClick = false;
      let pressedItem = null;

      scroller.addEventListener('pointerdown', (event) => {
        if (scroller.scrollWidth <= scroller.clientWidth || event.button > 0) return;

        pointerId = event.pointerId;
        startX = event.clientX;
        startScrollLeft = scroller.scrollLeft;
        hasMoved = false;
        pressedItem = getItemFromEvent(event);
        scroller.setPointerCapture(pointerId);
      });

      scroller.addEventListener('pointermove', (event) => {
        if (pointerId !== event.pointerId) return;

        const deltaX = event.clientX - startX;
        if (Math.abs(deltaX) > 4) {
          hasMoved = true;
          scroller.classList.add('is-dragging');
          event.preventDefault();
        }

        scroller.scrollLeft = startScrollLeft - deltaX;
      });

      const endDrag = (event) => {
        if (pointerId !== event.pointerId) return;

        pointerId = null;
        scroller.classList.remove('is-dragging');

        if (!hasMoved && pressedItem) {
          scrollToItemTarget(pressedItem);
          suppressClick = true;
        } else if (hasMoved) {
          suppressClick = true;
        }

        pressedItem = null;
        window.setTimeout(() => {
          suppressClick = false;
        }, 120);
      };

      scroller.addEventListener('pointerup', endDrag);
      scroller.addEventListener('pointercancel', endDrag);
      scroller.addEventListener('lostpointercapture', () => {
        pointerId = null;
        pressedItem = null;
        scroller.classList.remove('is-dragging');
      });

      scroller.addEventListener(
        'click',
        (event) => {
          if (!suppressClick) return;

          event.preventDefault();
          event.stopImmediatePropagation();
        },
        true
      );
    };

    const initDragScroll = () => {
      updateScrollerState();
      initNativeDragScroll();
    };

    if (document.readyState === 'loading') {
      window.addEventListener('DOMContentLoaded', initDragScroll, { once: true });
    } else {
      initDragScroll();
    }

    window.addEventListener('resize', updateScrollerState);

    const scrollActiveItemIntoView = (item) => {
      if (!scroller || !item || scroller.scrollWidth <= scroller.clientWidth) return;

      const itemLeft = item.offsetLeft;
      const itemRight = itemLeft + item.offsetWidth;
      const viewLeft = scroller.scrollLeft;
      const viewRight = viewLeft + scroller.clientWidth;
      const edgePadding = 16;

      if (itemLeft < viewLeft + edgePadding) {
        scroller.scrollTo({
          left: Math.max(itemLeft - edgePadding, 0),
          behavior: 'smooth',
        });
      } else if (itemRight > viewRight - edgePadding) {
        scroller.scrollTo({
          left: itemRight - scroller.clientWidth + edgePadding,
          behavior: 'smooth',
        });
      }
    };

    const updateActive = () => {
      const offset = window.scrollY + nav.offsetHeight + 40;
      let active = null;
      items.forEach((item) => {
        const el = document.querySelector(item.dataset.target);
        if (!el) return;
        if (el.getBoundingClientRect().top + window.scrollY <= offset) active = item;
      });
      items.forEach((item) => item.classList.toggle('is-active', item === active));
      if (active !== activeItem) {
        activeItem = active;
        scrollActiveItemIntoView(activeItem);
      }
    };

    window.addEventListener('scroll', updateActive, { passive: true });
    updateActive();
  })();
